import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { PaymentsStore } from 'models/redux'
import { PaymentStep } from 'lib/enums/payments.enums'
import { IPlanInformation, ISelectedRecurrentPlan } from 'models/payments'
import { RESET_APP_STATE } from 'store/shared.actions'

const initialState: PaymentsStore = {
  paymentStep: PaymentStep.BILLING_INFORMATION,
  isRecurringPayment: false,
}

const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    setPaymentStep(state, action: PayloadAction<PaymentStep>) {
      state.paymentStep = action.payload
    },
    setSelectedRecurrentPlan(
      state,
      action: PayloadAction<ISelectedRecurrentPlan>
    ) {
      state.selectedRecurrentPlan = action.payload
    },
    setIsRecurringPayment(state, action: PayloadAction<boolean>) {
      state.isRecurringPayment = action.payload
    },
    setSelectedPlan(state, action: PayloadAction<IPlanInformation>) {
      state.selectedPlan = action.payload
    },
    resetPaymentsState(state) {
      return initialState
    },
  },
  extraReducers: builder => {
    builder.addCase(RESET_APP_STATE, state => {
      return initialState
    })
  },
})

export const {
  resetPaymentsState,
  setPaymentStep,
  setSelectedRecurrentPlan,
  setSelectedPlan,
  setIsRecurringPayment,
} = paymentsSlice.actions

export default paymentsSlice.reducer
